import { useCallback, useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { API_URL } from '../../config/api';
import { fetchSubscriptions, Stats, Subscription } from './model';

export default function useSubscriptionData() {
  const [items, setItems] = useState<Subscription[]>([]);
  const [stats, setStats] = useState<Stats | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [partial, setPartial] = useState(false);
  const [total, setTotal] = useState(0);
  const alive = useRef(true), generation = useRef(0);
  const reload = useCallback(async () => {
    const id = ++generation.current;
    setLoading(true); setError('');
    const [list, summary] = await Promise.allSettled([fetchSubscriptions(), axios.get<Stats>(`${API_URL}/admin/subscriptions/stats`)]);
    if (!alive.current || id !== generation.current) return;
    if (list.status === 'fulfilled') {
      setItems(list.value.items); setPartial(list.value.partial); setTotal(list.value.total);
    }
    if (summary.status === 'fulfilled') setStats(summary.value.data);
    const messages = [];
    if (list.status === 'rejected') messages.push('Abonelik listesi yüklenemedi. Önceki kayıtlar korunuyor.');
    if (summary.status === 'rejected') messages.push('Özet bilgiler yenilenemedi.');
    setError(messages.join(' ')); setLoading(false);
  }, []);
  useEffect(() => {
    alive.current = true; reload();
    return () => { alive.current = false; generation.current += 1; };
  }, [reload]);
  return { items, stats, loading, error, partial, total, reload };
}
